export default function DSA_Prims() {
  return <div>DSA_Prims Component</div>;
}
